
<mat-card class="form-container">
  <mat-card-title class="form-title">Upload Files</mat-card-title>




  <!-- Mode Selection -->
  <div>
    <label >Choose a Mode</label>
    <mat-form-field appearance="outline" class="custom-form-field">
      <!-- <mat-label>Choose a Mode</mat-label> -->
      <mat-select [(ngModel)]="selectedMode">
        <mat-option value="NORMAL">Normal Mode</mat-option>
        <mat-option value="EXPLORE">Explore Mode</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="upload-sample" (click)="triggerPopup()">
      <mat-icon class="upload-icon">description</mat-icon>
      <span class="upload-text ">Upload Sample File</span>
    </div>
  </div>


  <!-- <div class="nested-dropdown"> -->
    <!-- Model Selection -->
    <!-- <mat-form-field appearance="outline" class="custom-nested-form-field">
      <mat-label> Model</mat-label>
      <mat-select >
        <mat-option value="pricing-Engine">Pricing Engine </mat-option>
      </mat-select>
    </mat-form-field> -->

    <!-- Cost Model Selection -->
    <!-- <mat-form-field appearance="outline" class="custom-nested-form-field">
      <mat-label> Cost Pricing</mat-label>
      <mat-select >
        <mat-option value="cost-plus-pricing">Cost Plus Pricing</mat-option>
      </mat-select>
    </mat-form-field>
  </div> -->





  <div class="selected-mode" *ngIf="selectedMode">
    <mat-icon>check_circle</mat-icon>
    <span>You selected: <strong>{{ selectedMode }}</strong></span>
  </div>

 <!-- CSV File Upload -->
<div class="file-upload" *ngIf="selectedMode && selectedMode !== 'NORMAL'">
  <label class="mt-2 text-sm">Upload your CSV file</label>
  <div class="upload-box">
    <input type="file" #csvInput (change)="onCsvFileChange($event)" accept=".csv" multiple hidden />
    <button mat-raised-button color="accent" (click)="csvInput.click()">Choose File</button>
  </div>

  <!-- Display number of selected CSV files below the button -->
  <div class="file-list" *ngIf="selectedCsvFiles.length > 0">
    <span *ngIf="selectedCsvFiles.length === 1">{{ selectedCsvFiles[0].name }}</span>
    <span *ngIf="selectedCsvFiles.length > 1">{{ selectedCsvFiles.length }} files selected</span>
  </div>
</div>


  <!-- Config File Upload -->
  <div class="file-upload">
    <label>Upload your Template file</label>
    <div class="upload-box">
      <input type="file" #configInput (change)="onConfigFileChange($event)" accept=".json" hidden />
      <button mat-raised-button color="accent" (click)="configInput.click()">Choose File</button>
    </div>

    <!-- Display selected Config file below the button -->
    <div class="file-list" *ngIf="configFileName">
      <span>{{ configFileName }}</span>
    </div>
  </div>


  <!-- Submit Button -->
  <button   class="submit-btn primary-bg text-white" (click)="submitFiles()">Submit</button>
</mat-card>
<!-- <app-loader *ngIf="isLoading"></app-loader> -->
